import type {ComponentType} from 'react';

import loadable from '@loadable/component';
import React from 'react';
import {Route} from 'react-router-dom';

import getSharedLoader from '../lib/router/getSharedLoader';
import Calendar from './MyPage/Calendar';
import CalendarRoutes from './MyPage/Calendar/CalendarRoutes';
import Discover from './MyPage/Discover';
import Member from './MyPage/Member';
import MentorshipRoutes from './MyPage/Mentorship/MentorshipRoutes';
import MyHome from './MyPage/MyHome';
import MyPageEvent from './MyPage/MyPageEvent';
import MyProfile from './MyPage/MyProfile';
import OAuthRoutes from './MyPage/OAuth/OAuthRoutes';
import SetupPublicProfileRoutes from './SetupPublicProfile/SetupPublicProfileRoutes';

const MyPageLayout = loadable(() => import('../layouts/my-page'));

export default (
  <Route Component={MyPageLayout as ComponentType}>
    <Route
      Component={MyHome as ComponentType}
      index={true}
      key="home"
      loader={getSharedLoader({
        loadableRoot: MyHome,
      })}
    />
    <Route
      Component={MyPageEvent as ComponentType}
      key="event"
      loader={getSharedLoader({
        loadableRoot: MyPageEvent,
      })}
      path="event/:id"
    />
    <Route
      Component={Discover as ComponentType}
      key="discover"
      loader={getSharedLoader({
        loadableRoot: Discover,
      })}
      path="discover"
    />
    <Route
      Component={Member as ComponentType}
      key="member"
      loader={getSharedLoader({
        loadableRoot: Member,
      })}
      path="member/:id"
    />
    <Route
      Component={MyProfile as ComponentType}
      key="my-profile"
      loader={getSharedLoader({
        loadableRoot: MyProfile,
      })}
      path="my-profile"
    />
    <Route
      Component={Calendar as ComponentType}
      loader={getSharedLoader({
        loadableRoot: Calendar,
      })}
      path="calendar"
    />
    {SetupPublicProfileRoutes}
    {MentorshipRoutes}
    {CalendarRoutes}
    {OAuthRoutes}
  </Route>
);
